/** ============================================================================
 * slider
 *
 * @version   1.0.0
 * @author    Sam Rankin <srankin@riester.com>
 * @copyright 2022 RIESTER
 * ========================================================================== */

import { tns } from 'tiny-slider';

import { css, extend, get, getTallest, has, isEmpty, stringToHtml } from '../utils';

import leftArrow from 'bootstrap-icons/icons/chevron-left.svg?raw';
import rightArrow from 'bootstrap-icons/icons/chevron-right.svg?raw';
import bullet from 'bootstrap-icons/icons/circle.svg?raw';
import bulletActive from 'bootstrap-icons/icons/circle-fill.svg?raw';

const defaults = {
	container: '.tns',
	navPosition: 'bottom',
	navAsThumbnails: false,
	mode: 'gallery',
	controlsText: ['<span aria-hidden="true" role="presentation" class="btn-icon">' + leftArrow + '</span>' + '<span class="btn-text visually-hidden">Previous</span>', '<span class="btn-text visually-hidden">Next</span>' + '<span aria-hidden="true" role="presentation" class="btn-icon">' + rightArrow + '</span>'],
	autoHeight: false,
	autoplayHoverPause: true,
	lazyloadSelector: '.lazyload',
	lazyload: true,
	updateSliderHeight: (elem) => {
		updateBtnPosition(elem);
	},
};

function changeActiveClass(navItem) {
	let button = navItem.querySelector('.btn');
	if (!isEmpty(button)) {
		if (navItem.classList.contains('tns-nav-active')) {
			button.classList.add('active');
		} else {
			button.classList.remove('active');
		}
	}
}

function changeActiveClasses(elem) {
	if (has(elem, 'navItems') && !isEmpty(elem.navItems)) {
		elem.navItems = elem.navItems.map(function (navItem) {
			changeActiveClass(navItem);
		});
	}
}

function updateBtnPosition(elem) {
	const sliderID = elem.container.getAttribute('id');
	const wrapperID = sliderID + '-ow';
	const wrapper = document.getElementById(wrapperID);
	const container = document.getElementById(sliderID);
	if (elem.hasControls) {
		elem.prevButton.classList.add('btn', 'prev');
		elem.nextButton.classList.add('btn', 'next');
		elem.prevButton.setAttribute('tabindex', '0');
		elem.nextButton.setAttribute('tabindex', '0');
		let sliderheight = container.offsetHeight;

		let navBtns = wrapper.querySelectorAll('.tns-controls .btn');

		if (navBtns.length) {
			navBtns.forEach(function (btn) {
				let topStyle = sliderheight * 0.5;
				btn.style.top = `${topStyle}px`;
			});
		}
	}
}

function createNav(elem, hasThumbnails) {
	if (has(elem, 'navItems') && !isEmpty(elem.navItems)) {
		let slides = elem.slideItems;
		slides = slides.filter(function (slide) {
			return !slide.classList.contains('tns-slide-cloned');
		});

		let navContainer = elem.navContainer;
		let standardNavContainer = navContainer.classList.length == 1 && navContainer.classList.contains('tns-nav'); // Make sure a custom nav container isn't specified
		if (standardNavContainer) {
			elem.navItems.forEach(function (el, i) {
				let navItem = el.cloneNode();
				navItem.setAttribute('tabindex', '0');
				navItem.classList.add('btn');
				navItem.classList.add('btn-link');
				let navItemContent = stringToHtml(`<span aria-hidden="true" role="presentation" class="btn-icon"><span aria-hidden="true" role="presentation" class="btn-icon-opened">${bulletActive}</span><span aria-hidden="true" role="presentation" class="btn-icon-closed">${bullet}</span></span>`);
				if (hasThumbnails) {
					let slide = slides[i];
					let thumb = slide.querySelector('img').cloneNode();

					let thumbWrapper = stringToHtml('<span aria-hidden="true" role="presentation" class="btn-icon"></span>');
					thumbWrapper.append(thumb);
					navItemContent = thumbWrapper;
				} else {
					navItem.classList.add('btn-toggle');
				}

				navItem.append(navItemContent);
				let navItemWrapper = stringToHtml('<span class="tns-nav-item"></span>');
				navItemWrapper.append(navItem);

				navItem = navItemWrapper;

				changeActiveClass(navItem);

				el.parentNode.replaceChild(navItem, el);
			});
			if (hasThumbnails) {
				navContainer.classList.add('tns-thumbnails');
			}
		}
	}
}

function slider(element, args = {}) {
	if (!isEmpty(args)) {
		args = extend(args, defaults);
	} else {
		args = defaults;
	}

	let inlineArgs = element.getAttribute('data-tns');
	if (!isEmpty(inlineArgs)) {
		inlineArgs = JSON.parse(inlineArgs);
		args = extend(inlineArgs, args);
	}

	const hasThumbnails = get(args, 'navAsThumbnails', false);

	if (hasThumbnails) {
		args.slideBy = 1;
	}

	let init = (slider) => {
		updateBtnPosition(slider);

		createNav(slider, hasThumbnails);

		var tallest = getTallest('.tns-item');

		css(slider.container, {
			'min-height': tallest + 'px',
		});
	};

	if (!has(args, 'onInit')) {
		args.onInit = init;
	}

	args.container = element;

	let sliderInstance = tns(args);

	sliderInstance.events.on('indexChanged', changeActiveClasses);

	return sliderInstance;
}

export default { slider };

window.addEventListener('load', function () {
	let sliders = document.querySelectorAll('.tns');
	if (sliders.length > 0) {
		sliders.forEach((element) => {
			var slide = slider(element);
			return slide;
		});
	}
});
